import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import PlacementTestFormService from '../services/PlacementTestFormService';
import ItemFormContainer from '../../item/components/ItemFormContainer';
import Async from '../../../core/layout/Async';

class PlacementTestItemFormContainer extends Component {
  static propTypes = {
    placementTestId: PropTypes.string.isRequired,
    onSaveSuccess: PropTypes.func.isRequired,
  };

  placementTestFormService = new PlacementTestFormService();
  componentWillMount() {
    this.placementTestFormService.handleLoad(this.props.placementTestId);
  }

  render() {
    if (!this.placementTestFormService.form.getValue('grammar')) {
      return <Async fetching={true} />;
    }
    return (
      <ItemFormContainer
        itemsTypeUrl="/item-types?allowedForPlacementTest=true"
        endpointUrl={`grammar-placement-test-levels/${this.props.placementTestId}/items`}
        onSaveSuccess={this.props.onSaveSuccess}
        defaultGrammar={this.placementTestFormService.form.getValue('grammar')}
        timeProperty="defaultPlacementTestTime"
        isTestItem
      />
    );
  }
}

export default observer(PlacementTestItemFormContainer);
